import React, { Component } from "react";
import { func, string, number } from "prop-types";
import swal from "sweetalert2";
import filesize from "filesize";
import styles from "./styles.module.scss";

class UploadButton extends Component {
  state = {
    filename: null,
    id: Math.random()
      .toString(36)
      .substring(2),
  };

  onChange = ({
    target: {
      files: [file],
    },
  }) => {
    if (file) {
      // TODO: Hack for MS Edge. Should be removed if Edge 18 will not be supported.
      if (this.props.accept.includes("image") && !file.type.includes("image")) {
        swal("Type error!", `File should have image type`, "warning");

        return;
      }
      const isExceedsMaxSize = file.size > this.props.maxFileSize;

      if (isExceedsMaxSize) {
        return this.notifySizeExceeding();
      }

      this.props.onSelectFile(file);
      this.setState({ filename: file.name });
    }
  };

  notifySizeExceeding = () => {
    const { maxFileSize } = this.props;

    swal(
      "File size is too big!",
      `Please make sure the file size is less than ${filesize(maxFileSize)}`,
      "warning",
    );
  };

  render() {
    const { filename } = this.state;
    const { accept, defaultText } = this.props;

    return (
      <>
        <input
          id={this.state.id}
          type="file"
          style={{ display: "none" }}
          onChange={this.onChange}
          accept={accept}
        />
        <label
          htmlFor={this.state.id}
          className={`${styles.upload} btn btn-secondary`}>
          <i className="fa fa-upload mr-2" />
          <span>{filename || defaultText}</span>
        </label>
      </>
    );
  }
}

UploadButton.propTypes = {
  accept: string.isRequired,
  maxFileSize: number /* in bytes */,
  onSelectFile: func.isRequired,
  defaultText: string,
};

UploadButton.defaultProps = {
  accept: "*",
  defaultText: "Attach application document",
};

export default UploadButton;
